<template>

    <v-app>
        <!-- ── Navigation Drawer ─────────────────────────── -->
        <v-navigation-drawer
            v-model="drawer"
            v-if="mainStore.isLoggedIn"
            app
            :clipped="$vuetify.breakpoint.lgAndUp"
            width="260"
            class="drawer-professional"
        >
            <!-- Header del drawer -->
            <div class="drawer-header pa-4">
                <p class="drawer-school-name">Colegio Hacienda<br/>Los Alcaparros</p>
                <p class="drawer-exercise-label">{{ $t('welcome.title') }}</p>
            </div>

            <v-divider></v-divider>

            <v-divider class="mx-3 mb-1"></v-divider>
            <p class="drawer-section-label px-4 mt-2 mb-1">{{ $t('nav.sections_label') }}</p>

            <v-list dense nav>
              <v-list-item
                v-for="(sec, i) in surveySections"
                :key="i"
                class="drawer-item mb-1"
                rounded
                :class="{ 'drawer-item-active': mainStore.current_block === i + 1 && $route.name === 'TeacherSurvey' }"
                @click="navigateToSection(i + 1)"
              >
                <v-list-item-icon class="mr-2" style="min-width:26px; margin-top:10px">
                  <span class="section-letter-chip" :class="{ 'section-letter-chip--active': mainStore.current_block === i + 1 && $route.name === 'TeacherSurvey' }">
                    {{ String.fromCharCode(65 + i) }}
                  </span>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="drawer-section-item-title">
                    {{ sec }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>

            <!-- Footer del drawer -->
            <template v-slot:append>
                <v-divider></v-divider>
                <div class="drawer-footer pa-3">
                    <div class="d-flex align-center">
                        <v-icon size="14" color="grey lighten-1" class="mr-2">mdi-circle</v-icon>
                        <span class="drawer-user-name">{{ mainStore.logged_user.name }}</span>
                    </div>
                </div>
            </template>
        </v-navigation-drawer>

        <!-- ── App Bar ───────────────────────────────────── -->
        <v-app-bar
            :clipped-left="$vuetify.breakpoint.lgAndUp"
            color="primary"
            app
            elevation="0"
            class="appbar-professional"
        >
            <v-app-bar-nav-icon
                v-if="mainStore.isLoggedIn"
                @click.stop="drawer = !drawer"
                class="white--text"
            />

            <!-- Logos -->
            <div class="d-flex align-center ml-1">
                <img src="/images/logo_colegio.jpg" alt="Logo Colegio"
                     style="height:38px; width:auto; border-radius:6px; margin-right:10px;" />
                <span class="appbar-title d-none d-sm-inline">
                    Colegio Hacienda Los Alcaparros
                </span>
            </div>

            <v-spacer></v-spacer>

            <v-toolbar-items v-if="mainStore.isLoggedIn">
                <LocaleSwitcher/>
                <!-- Separador visual -->
                <div class="appbar-separator mx-2"></div>
                <!-- Nombre del usuario -->
                <div class="d-flex align-center appbar-user px-2">
                    <v-icon small class="white--text mr-1" style="opacity:0.7">mdi-account-circle-outline</v-icon>
                    <span class="white--text appbar-user-name d-none d-sm-inline">
                        {{ mainStore.logged_user.name }}
                    </span>
                </div>
                <!-- Logout -->
                <v-btn icon small @click="mainStore.logout" class="white--text ml-1" title="Cerrar sesión">
                    <v-icon size="18">mdi-logout</v-icon>
                </v-btn>
            </v-toolbar-items>
            <v-toolbar-items v-else>
                <LocaleSwitcher/>
            </v-toolbar-items>
        </v-app-bar>

        <header>
        <link href="https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900" rel="stylesheet">
        <link href="https://cdn.jsdelivr.net/npm/@mdi/font@6.x/css/materialdesignicons.min.css" rel="stylesheet">
        
        </header>
        <v-main>
                <!-- <vue-particles color="#7afff6"/> -->

                <flash-message style="height: 8px; padding-top: 40px;"/>
                <keep-alive >
                    <router-view></router-view>
                </keep-alive>
                <loader/>  
        </v-main>

        <v-footer/>
    </v-app>

</template>

<script >

 import { useMainStore } from '@/store/main'
 import { mapStores} from 'pinia'
 import LocaleSwitcher from './components/LocaleSwitcher.vue';
 import Loader from './components/partials/_loader';
 import flashMessage from './components/partials/flashMessage';


 export default{
    data() {
        return {
            drawer: false,
            menus: [
                { 
                    icon: "mdi-crowd",
                    text: `${this.$t('menus.active_source')}`, 
                    route: "ActiveSource", 
                    roles: ["Admin"],
                    visible:true
                },
                
                // {
                //     icon: "mdi-account-group",
                //     text: `${this.$t('menus.culture')}`, 
                //     route: "Culture",
                //     roles: ["Admin"],
                //     visible:true
                // }
            ]
        };
    },

    
    components: { 
        LocaleSwitcher,
        Loader,
        flashMessage,
       
    },
    
    created() {


        if (this.mainStore.isLoggedIn) {
            this.mainStore.initialize();
            this.mainStore.setLoggedUser();
        }

        this.$axios.interceptors.request.use((config) => {
            // Do something before request is sent
            this.mainStore.loader= true;
            return config;
        }, (error) => {
            // Do something with request error
            this.mainStore.loader = false;
            return Promise.reject(error);
        });

        // Add a response interceptor
        this.$axios.interceptors.response.use((response) => {
            // Do something with response data
            this.mainStore.loader = false;
            return response;
        }, (error) => {
            this.mainStore.loader=false;
            //console.log(error);
            // Do something with response error
            if (error.response.status == 401) {

               // console.log('Ocurre error 401!');
                this.mainStore.$reset();
                localStorage.removeItem('access_token');
                this.mainStore.logged_user=Object.assign({},{id:'',
                                                            name:'',
                                                            email:'',
                                                            role:''});
                this.mainStore.token='';
                if (['login.invalid_token','login.missing_token'].includes(error.response.data.message)){
                    this.mainStore.setFlashMessage({message:'login.invalid_or_expired_token',type:'error'});
                    
                    this.$router.push('/login');
                    
                }
                    
            }

            return Promise.reject(error);
        });
    },

    computed: {
        ...mapStores(useMainStore),
        surveySections() {
          return [
            this.$t('nav.section_1'),
            this.$t('nav.section_2'),
            this.$t('nav.section_3'),
            this.$t('nav.section_4'),
            this.$t('nav.section_5'),
            this.$t('nav.section_6'),
          ];
        },
        current_network_mode() {
            // Detecta el modo activo según la selección actual
            return this.mainStore.network_modes.find(
              m => this.selected_network_mode_theme && m.id_network_mode === this.selected_network_mode_theme.id_network_mode
            ) || null;
          },
    },

    watch:{

      '$i18n.locale'(){

       this.translateMenus();


      },
      'mainStore.isLoggedIn'(val) {
        if (val) {
          this.mainStore.setFlashMessage({ message: '¡Bienvenido/a!', type: 'success' });
        }
      },
    },
    methods: {

      translateMenus(){
        if (this.menus[0]) this.menus[0].text = this.$t('menus.active_source');
      },
      testFlashMessage() {
        this.mainStore.setFlashMessage({ message: '¡Pop-up funcionando!', type: 'success' });
      },
      navigateToSection(blockIndex) {
        this.mainStore.goToBlock(blockIndex);
        if (this.$route.name !== 'TeacherSurvey') {
          this.$router.push({ name: 'TeacherSurvey' });
        }
      },
      setNetworkModeFromSidebar(mode) {
        // Cambia el modo de red activo al hacer clic en la barra lateral
        this.$emit('update:selected_network_mode_theme', mode);
        // Si usas Pinia o Vuex para la selección, actualiza ahí también
        // this.mainStore.selected_network_mode = mode;
      },
    }
}

</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@400;500;600;700&display=swap');

* {
  font-family: 'Quicksand', 'Roboto', Arial, sans-serif !important;
}

/* ── Navigation Drawer ─────────────────────────────────────── */
.drawer-professional {
  border-right: 1px solid #e2e8f0 !important;
}

.drawer-header {
  background: #1e3a5f;
}

.drawer-school-name {
  font-size: 0.85rem;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 2px 0;
  line-height: 1.3;
}

.drawer-exercise-label {
  font-size: 0.7rem;
  font-weight: 500;
  color: rgba(255,255,255,0.6);
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.drawer-section-label {
  font-size: 0.68rem;
  font-weight: 700;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.drawer-item {
  border-radius: 8px !important;
}

.drawer-item-active {
  background: #eff6ff !important;
  color: #1e3a5f !important;
  font-weight: 700 !important;
}

.drawer-item-active .v-icon {
  color: #1e3a5f !important;
}

.drawer-item-title {
  font-size: 0.875rem !important;
  font-weight: 500;
  color: #374151;
}

.drawer-section-item-title {
  font-size: 0.8rem !important;
  font-weight: 500;
  color: #374151;
  white-space: normal !important;
  line-height: 1.3 !important;
}

.section-letter-chip {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #e2e8f0;
  color: #374151;
  font-size: 0.65rem;
  font-weight: 700;
  flex-shrink: 0;
}

.section-letter-chip--active {
  background: #1e3a5f;
  color: white;
}

.drawer-item-active .drawer-item-title {
  color: #1e3a5f !important;
  font-weight: 700 !important;
}

.drawer-footer {
  background: #f9fafb;
}

.drawer-user-name {
  font-size: 0.78rem;
  color: #6b7280;
  font-weight: 500;
}

/* ── App Bar ────────────────────────────────────────────────── */
.appbar-professional {
  border-bottom: 1px solid rgba(255,255,255,0.1) !important;
}

.appbar-title {
  font-size: 0.88rem;
  font-weight: 600;
  color: rgba(255,255,255,0.9);
  letter-spacing: 0.01em;
}

.appbar-separator {
  width: 1px;
  height: 20px;
  background: rgba(255,255,255,0.25);
  align-self: center;
}

.appbar-user {
  height: 100%;
}

.appbar-user-name {
  font-size: 0.82rem;
  font-weight: 500;
  opacity: 0.85;
}
</style>

